import { SocialApiResponse } from "@/lib/definitions";
import { createErrorMsg, restErrors } from "@/lib/utils";


/**
 * Calls api GET using args for easy seamless code integration
 * @param token can be url, or short id
 * @param access_token 
 * @returns is member
 */
export async function socialCheck(url_or_id: string, asVideo?: boolean) {
    if (!url_or_id)
        throw new Error(`Missing args, missing: {url_or_id} - a url / id of a video or channel`);

    let inputUrl = url_or_id;

    //if asked as a video we might need to prefix with "watch?v=" if we got just ID
    //if its a video url we need to strip all other url search params so we could effectively cache results
    let videoID = url_or_id
    if (asVideo) {
        if (url_or_id.length > 20) {//if length is too big - assume url
            //url validation handling ()
            let url: URL
            try {
                url = new URL(url_or_id)
                const v = url.searchParams.get("v") //extract only videoID
                if (!v || v.length < 6 || v.length > 12) //if {v} search params is not valid raise error
                    throw new Error("Invalid videoID")
                videoID = v; //save video id to external if scope
            } catch (e) {
                return createErrorMsg("קישור לא תקין")
            } //if failed parsing URL
        }//else assume direct videoID as we got less the 20 chars
        inputUrl = `https://www.youtube.com/watch?v=${videoID}`;
    }

    const res = await fetch(`${process.env.SITE_URL || "/"}api/social?channel=${inputUrl}`, { next: { "revalidate": 60 * 10 } });
    //handle api Error
    if (!res.ok) {
        //if intended error by API
        if (res.status == 400) {
            let { error } = await res.json()
            if (asVideo)
                error = error.replace("ערוץ", "קישור")
            return createErrorMsg(error);
        }
        return restErrors.serverError
    }
    const apiRes = await res.json() as SocialApiResponse;
    if (asVideo) {
        return {
            ...apiRes,
            videoID
        }
    }
    return apiRes;
}

